module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CT"
  }, [_vm._v("Honey Bee")]), _vm._v(" "), _c('p', {
    staticClass: "CH-INTRO1"
  }, [_vm._v("Honey Bee can be worked by hand or machine and incorporates some hand appliqué. It is one of those classic blocks that could be repeated several times in a sampler quilt, giving a chance to play with colour combinations.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/D_Wing_HoneyBee_Block2_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Colour Choices")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Three or more fabrics are used in Honey Bee, so it is a good design for using up scraps. The curved appliqué shapes are meant to represent bees and the centre nine-patch probably the bee hive. Choose the fabrics to suit your quilt, referring to other blocks you may already have completed to see what is needed for balance.")]), _vm._v(" "), _c('h2', {
    staticClass: "AHD"
  }, [_vm._v("Directions")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("1 This block is machine pieced, with "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (6mm) seams. Cut out nine squares measuring 2 "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (6.3cm) × 2 "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (6.3cm) – five in one fabric, four in another. Cut four rectangles measuring 6"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (16.5cm) × 3 "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (8.9cm) and four squares measuring 3 "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (8.9cm) × 3 "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (8.9cm). Seam allowances have been included in these measurements.")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("2 Assemble the central Nine-Patch square by stitching three rows of three squares each. From the front, press the seams towards the darker fabric ("), _c('a', {
    attrs: {
      "href": "#/#fig-1a"
    }
  }, [_vm._v("Fig 1a")]), _vm._v("). Join the rows together to make a Nine-Patch square ("), _c('a', {
    attrs: {
      "href": "#/#fig-1b"
    }
  }, [_vm._v("Fig 1b")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p102-003_col_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-1a"
    }
  }, [_vm._v("Fig 1a")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p102-004_col_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-1b"
    }
  }, [_vm._v("Fig 1b")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("3 Now, on either side of the Nine-Patch join on the two side rectangles or B shapes ("), _c('a', {
    attrs: {
      "href": "#/#fig-2"
    }
  }, [_vm._v("Fig 2")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p104-001_col_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-2"
    }
  }, [_vm._v("Fig 2")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("4 Stitch together the top row of shapes C, B and C. From the front press the seams towards shapes C ("), _c('a', {
    attrs: {
      "href": "#/#fig-3"
    }
  }, [_vm._v("Fig 3")]), _vm._v("). Repeat this to make the bottom row.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p104-002_col_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-3"
    }
  }, [_vm._v("Fig 3")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("5 Join the three rows together, locking the seams so that they match exactly ("), _c('a', {
    attrs: {
      "href": "#/#fig-4a"
    }
  }, [_vm._v("Figs 4a")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/#fig-4b"
    }
  }, [_vm._v("4b")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p104-003_col_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-4a"
    }
  }, [_vm._v("Fig 4a")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p104-004_col_fmt.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-4b"
    }
  }, [_vm._v("Fig 4b")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("6 Shapes D and E in "), _c('a', {
    attrs: {
      "href": "#/#fig-5"
    }
  }, [_vm._v("Fig 5")]), _vm._v(" represent the bee’s body and wing. Four body shapes and eight wing shapes are needed. The appliqué can be done by needle marking, as follows. Print templates of shapes D and E. Put the templates on the fabric and draw around the edge firmly with a blunt-ended needle to make a creased line. Cut out the fabric shape with a "), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in (6mm) seam allowance. Tack (baste) under the seam allowances, following the needle-marked creases.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/honey-bee-fig5_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-5"
    }
  }, [_vm._v("Fig 5")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("7 Arrange the four body shapes and eight wings on the pieced block ("), _c('a', {
    attrs: {
      "href": "#/#fig-6"
    }
  }, [_vm._v("Fig 6")]), _vm._v(") and pin in place. Sew each one on to the background with small slip stitches, using thread to match the appliqué. Once completed, the backing fabric can be cut away to reduce the bulk.")]), _vm._v(" "), _c('p', {
    staticClass: "Image-C"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/p104-006_col_fmt.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "IMG-HD",
    attrs: {
      "id": "fig-6"
    }
  }, [_vm._v("Fig 6")]), _vm._v(" "), _c('p', {
    staticClass: "SbS1"
  }, [_vm._v("8 Press the completed block from the front and measure it – it should be 12"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (31.7cm) square. Add framing sashing strips if desired. To make the block up to 14in (35.5cm) square, cut two strips 1"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in × 12"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("2")])]), _vm._v("in (3.2 × 31.7cm) and sew to the sides of the block. Press the seams outwards. Cut two strips 1"), _c('span', {
    staticClass: "fractions"
  }, [_c('sup', [_vm._v("1")]), _vm._v("⁄"), _c('sub', [_vm._v("4")])]), _vm._v("in × 14in (3.2cm × 35.5cm) and sew to the top and bottom of the block. Press the seams outwards.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b741ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c02.vue
// module id = 66
// module chunks = 0